import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle } from '@fortawesome/free-solid-svg-icons';

/**
 * Resolve the display URL for a user's profile photo S3 key.
 * Returns null if the photo field is absent or empty.
 */
function resolvePhotoUrl(photo) {
  if (!photo || photo.trim().length === 0) return null;

  let url = photo.trim();

  // Raw filename (no path separator) → resolve under headshots dir
  if (url.indexOf('/') < 0) {
    url = `/images/headshots/${url}`;
  }

  // Ensure absolute path
  if (!url.startsWith('/') && !url.startsWith('http')) {
    url = `/${url}`;
  }

  return url;
}

/**
 * UserAvatar
 *
 * Renders the user's profile photo when available, falling back to a
 * FontAwesome user-circle icon when the photo field is absent or empty.
 *
 * Props:
 *   user  — object with a `photo` field (string | null | undefined)
 *   size  — pixel size for both width and height (default: 32)
 */
const UserAvatar = ({ user, size = 32 }) => {
  const [imgError, setImgError] = useState(false);
  const photoUrl = resolvePhotoUrl(user?.photo);

  if (photoUrl && !imgError) {
    return (
      <img
        src={photoUrl}
        alt={user?.name || 'User'}
        width={size}
        height={size}
        loading="lazy"
        onError={() => setImgError(true)}
        style={{
          borderRadius: '50%',
          objectFit: 'cover',
          flexShrink: 0,
        }}
      />
    );
  }

  return (
    <FontAwesomeIcon
      icon={faUserCircle}
      style={{ width: size, height: size, flexShrink: 0 }}
    />
  );
};

export default UserAvatar;
